import { fetcher } from "utils/ApiUtil";

export type ICategoryType = string;

export interface ICompanyCategory {
  no?: number;
  category?: ICategoryType;
  ordering?: number;
  home_yn?: "Y" | "N";
  del_yn?: "Y" | "N";
}

export async function getCompanyCategoryList() {
  return await fetcher<{ result: ICompanyCategory[] }>(
    "/api/contructor/categoryList"
  );
}

export async function contructorReserveClick({
  contructor_no,
  contructor_spot_no,
}: {
  contructor_no: number;
  contructor_spot_no?: number;
}) {
  return await fetcher<{ result: ICompanyCategory[] }>(
    "/api/contructor/reserveClick",
    { contructor_no, contructor_spot_no }
  );
}
